export default "__VITE_ASSET__BTUzQAjE__"